import { ReconciliationOverview } from "@/features/oversight/reconciliation";

export default function ReconciliationPage() {
  return <ReconciliationOverview />;
}
